<template>
    <button @mouseenter="setTooltip()" @mouseleave="setTooltip()" :class="{active: (shape.locked === true || shape.custom.locked === true)}" class="btn btn-icon waves-effect btn-default waves-light" @click="lock()" v-if="type === 'editor'">
      <i class="icon-lock"></i>
    </button>
</template>

<script>
export default {
    name: 'lock',
    props: {
        shape: {
            default: {
                locked: false
            }
        },
        type: {
            default: 'designer'
        }
    },
    methods: {
        lock: function () {
            this.$emit('lock')
        },
        setTooltip: function () {
            this.$emit('tooltip')
        }
    }
}
</script>



// WEBPACK FOOTER //
// lock.vue?7230f9d6